import { Alert, Button, Text } from '@change/ds-core-ui';

import { Translate, TranslatePlural } from '@change-corgi/core/react/i18n';

import { useFreePromotionNotification } from './hooks/useFreePromotionNotification';

type Props = {
	onDismiss?: () => void;
};

export function FreePromotionNotification({ onDismiss }: Props) {
	const { data, actions } = useFreePromotionNotification({ onDismiss });

	return (
		<Alert
			className="h-full w-full [&>div>div]:flex-row"
			variant="info"
			{...(onDismiss && {
				onDismissClick: actions.handleDismiss,
				dismissButtonAriaLabel: 'Close free promotion notification',
			})}
			heading={<Translate value="corgi.petition.starter_dashboard.notifications.free_promo.title" />}
			data-qa="free-promotion-section-message"
		>
			<Text as="p">
				<TranslatePlural
					value="corgi.petition.starter_dashboard.notifications.free_promo.body"
					replacements={{ impressions: data.impressions, amount: data.amountFormatted }}
					count={data.impressions}
				/>
			</Text>
			<Button
				className="mt-4"
				data-testid="free-promotion-button"
				variant="secondary-solid"
				size="x-small"
				// loading={data.loading}
				onClick={actions.handleCreateFreePromotion}
			>
				<Translate value="corgi.petition.starter_dashboard.notifications.free_promo.promote_button" />
			</Button>
		</Alert>
	);
}
